/* Canigloo — points de pagination sous les carrousels mobiles (≤760 px).
   Cible les grilles transformées en carrousels par la couche responsive de
   canigloo.css. Un point par carte, point actif suivi au scroll, clic = aller
   à la carte. Desktop : masqué en CSS. Init bornée (pages React montées tard). */
(function () {
  'use strict';
  var SELS = '.cg-swipe, .cgft-trust, .pdp-steps, .ap-values, .blog-start-grid, .blog-grid';

  function initGrille(grille) {
    if (grille.getAttribute('data-cgdots') === '1') return;
    var cartes = [];
    for (var i = 0; i < grille.children.length; i++) {
      if (grille.children[i].nodeType === 1) cartes.push(grille.children[i]);
    }
    if (cartes.length < 2) return;
    grille.setAttribute('data-cgdots', '1');

    var dots = document.createElement('div');
    dots.className = 'cg-dots';
    var boutons = [];
    cartes.forEach(function (c, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Carte ' + (idx + 1) + ' sur ' + cartes.length);
      b.addEventListener('click', function () {
        grille.scrollTo({ left: cartes[idx].offsetLeft - cartes[0].offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
      boutons.push(b);
    });
    grille.parentNode.insertBefore(dots, grille.nextSibling);

    var raf = null;
    function maj() {
      raf = null;
      /* visible seulement si le contenu scrolle vraiment (mode carrousel) */
      var scrolle = grille.scrollWidth > grille.clientWidth + 10;
      dots.style.display = scrolle ? '' : 'none';
      if (!scrolle) return;
      var pos = grille.scrollLeft, base = cartes[0].offsetLeft, actif = 0, dmin = 1e9;
      for (var j = 0; j < cartes.length; j++) {
        var d = Math.abs((cartes[j].offsetLeft - base) - pos);
        if (d < dmin) { dmin = d; actif = j; }
      }
      for (var k = 0; k < boutons.length; k++) {
        boutons[k].className = (k === actif) ? 'actif' : '';
      }
    }
    grille.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(maj);
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!raf) raf = requestAnimationFrame(maj);
    });
    maj();
  }

  function balayer() {
    var grilles = document.querySelectorAll(SELS);
    for (var i = 0; i < grilles.length; i++) initGrille(grilles[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', balayer);
  else balayer();
  /* pages React : le contenu monte après coup -> re-balayage borné (15 x 400 ms) */
  var essais = 0;
  var iv = setInterval(function () {
    essais++;
    balayer();
    if (essais >= 15) clearInterval(iv);
  }, 400);
  /* rechargement de section dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', balayer);
})();
